import { Container } from "aurelia-framework";
import store from "../store";
import { IState } from "../state";
import { Api } from "../../services/api";
import { applicationLogger } from "../../logging/logger";
import { Location } from "../../models/location";
import { Structure } from "../../models/structure";
import { Zone } from "../../models/zone";
import { WebApiResponse } from "../../models/web-api-response";

const api: Api = Container.instance.get(Api);

export async function updateStructure(state: IState, structure: Structure, locationId: string, zoneId: string): Promise<IState> {
	const newState = Object.assign({}, state);

	applicationLogger.debug(`Updating structure: ${structure.code} (location ${locationId}, zone ${zoneId})`);

	let location = newState.locationState.locations.find((l: Location) => l.id === locationId);
	if (location) {
		let zone = location.zones.find((z: Zone) => z.id === zoneId);
		if (zone) {
			let structureIndex = zone.structures.findIndex(((s: Structure) => s.id === structure.id) as any);
			if (structureIndex > -1) {
				zone.structures[structureIndex] = structure;

				// NB:  we should save the location here as "selectedLocations may not have the location.
				const response = await api.updateStructure(structure);
				if (!response.success) {
					return state;
				} else {
					return newState;
				}
			}
		}
	}

	location = newState.locationState.selectedLocations.find((l: Location) => l.id === locationId);
	if (location) {
		let zone = location.zones.find((z: Zone) => z.id === zoneId);
		if (zone) {
			let structureIndex = zone.structures.findIndex(((s: Structure) => s.id === structure.id) as any);
			if (structureIndex > -1) {
				zone.structures[structureIndex] = structure;
			}
		}
	}

	return newState;
}

// register actions here...
store.registerAction("updateStructure", updateStructure);
